<template>
  <v-menu class="flyers-table-actions" bottom origin="center center" transition="scale-transition" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <mf-button color="cinza-0" icon="more_vert" type="icon" v-on:click.native="on.click" />
    </template>

    <v-list v-if="!isFranchise">
      <v-list-item v-if="showResults" @click="redirectToResults">
        <v-list-item-title>Resultados</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="showEdit" @click="redirectToEdit">
        <v-list-item-title>Editar</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="showEnable" @click="confirmEnable">
        <v-list-item-title>Ativar</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="showDisable" @click="suspendFlyer">
        <v-list-item-title>Suspender</v-list-item-title>
      </v-list-item>
      <v-list-item @click="clone">
        <v-list-item-title>Duplicar</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="showDelete" @click="remove">
        <v-list-item-title>Apagar rascunho</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$emit('open-logs-modal', flyerId)">
        <v-list-item-title>Logs</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list v-else>
      <v-list-item @click="redirectToView">
        <v-list-item-title>Visualizar</v-list-item-title>
      </v-list-item>
    </v-list>
    <suspend-flyer v-model="dialog" :associated-campaigns="associatedCampaigns" @suspend-flyer="suspendFlyer()" />
  </v-menu>
</template>

<script>
import SuspendFlyer from '@/modules/mobile/chatbot/views/pages/SuspendFlyer.vue'
import { MUTATION_TOGGLE_FLYER, MUTATION_CLONE_FLYER, MUTATION_DELETE_FLYER } from '../../graphql'

export default {
  components: {
    SuspendFlyer,
  },
  props: {
    flyerId: String,
    flyerTitle: String,
    status: String,
    enableExportCsv: Boolean,
    isFranchise: Boolean,
  },
  data: () => ({
    dialog: false,
    filters: {
      campaign_status: ['active', 'scheduled'],
      flyer_id: null,
    },
    associatedCampaigns: null,
  }),
  computed: {
    showResults() {
      return ['finished', 'active', 'paused'].includes(this.status.toLowerCase())
    },
    showEdit() {
      return ['draft'].includes(this.status.toLowerCase())
    },
    showEnable() {
      return ['paused'].includes(this.status.toLowerCase())
    },
    showDisable() {
      return ['active', 'scheduled'].includes(this.status.toLowerCase())
    },
    showExportCsv() {
      if (this.enableExportCsv) return
      return ['active', 'scheduled', 'paused', 'finished'].includes(this.status.toLowerCase())
    },
    showDelete() {
      return ['draft'].includes(this.status.toLowerCase())
    },
  },
  methods: {
    redirectToResults() {
      this.$router.push(`/mobile/encartes/resultados/${this.flyerId}`).catch(() => {})
    },

    redirectToEdit() {
      this.$router.push(`/mobile/encartes/editar/${this.flyerId}`).catch(() => {})
    },

    confirmEnable() {
      if (this.status === 'paused') {
        this.$confirm({
          title: 'Ativar encarte',
          message: 'Você está prestes a ativar um encarte suspenso. Deseja continuar?',
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
        })
          .then(() => {
            this.enable()
          })
          .catch(() => {})
      } else {
        this.enable()
      }
    },

    async enable() {
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_TOGGLE_FLYER,
          variables: {
            _id: this.flyerId,
            active: true,
          },
        })
        this.$snackbar({ message: 'Encarte ativado com sucesso', snackbarColor: 'success' })
        this.$emit('updateTable')
      } catch (error) {
        this.$snackbar({ message: 'Erro ao ativar encarte', snackbarColor: 'error' })
      }
    },

    suspendFlyer() {
      this.$confirm({
        title: 'Suspender encarte',
        message: 'Este encarte será suspenso',
        confirmText: 'Ok',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          try {
            await this.$apollo.mutate({
              mutation: MUTATION_TOGGLE_FLYER,
              variables: {
                _id: this.flyerId,
                active: false,
              },
            })
            this.$emit('updateTable')
            this.$snackbar({ message: 'Encarte desativado com sucesso', snackbarColor: 'success' })
          } catch (error) {
            this.$snackbar({ message: 'Erro ao desativar flyer', snackbarColor: 'error' })
          }
        })
        .catch(() => {})
    },

    remove() {
      try {
        this.$confirm({
          title: 'Remover encarte',
          message: 'Tem certeza que deseja remover este encarte?',
          confirmText: 'Remover',
          confirmColor: 'vermelho-d20',
          cancelText: 'Cancelar',
        })
          .then(async () => {
            await this.$apollo.mutate({
              mutation: MUTATION_DELETE_FLYER,
              variables: {
                _id: this.flyerId,
              },
            })
            this.$emit('updateTable')
          })
          .catch(() => {})
      } catch (error) {
        this.$snackbar({ message: 'Erro ao remover encarte', snackbarColor: 'error' })
      }
    },

    clone() {
      this.$confirm({
        ...this.$t('campanhas.confirmations.clone'),
        message: `Deseja duplicar ${this.flyerTitle ? 'a campanha ' + this.flyerTitle.trim().bold() : 'esta campanha'}?`,
      })
        .then(async () => {
          try {
            const { data } = await this.$apollo.mutate({
              mutation: MUTATION_CLONE_FLYER,
              variables: {
                _id: this.flyerId,
              },
            })
            this.$router.push(`/mobile/encartes/editar/${data.cloneFlyer._id}`).catch(() => {})
          } catch (error) {
            this.$snackbar({ message: 'Erro ao duplicar encarte', snackbarColor: 'error' })
          }
        })
        .catch(() => {})
    },

    redirectToView() {
      this.$router.push({ path: `/mobile/encartes/visualizar/${this.flyerId}`, params: { readOnly: true } }).catch(() => {})
    },
  },
}
</script>

<style lang="scss">
.flyers-table-actions {
  i {
    opacity: 0.54;
  }
}
</style>
